module.exports = __webpack_public_path__ + "static/media/cars.507f213b.svg";